import geojs from './geojs';
import leaflet from './leaflet';
import openlayers from './openlayers';
import openseadragon from './openseadragon';
import slideatlas from './slideatlas';

export {
    geojs,
    leaflet,
    openlayers,
    openseadragon,
    slideatlas
};



// WEBPACK FOOTER //
// ./plugins/large_image/web_client/views/imageViewerWidget/index.js